
import dayjs from "dayjs";

import de from "dayjs/locale/de"
import es from "dayjs/locale/es"
import nl from "dayjs/locale/nl"
import ca from "dayjs/locale/ca"
import fr from "dayjs/locale/fr"


import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import duration from "dayjs/plugin/duration";
dayjs.extend(duration)
import weekday from "dayjs/plugin/weekday";
dayjs.extend(weekday)

import updateLocale from 'dayjs/plugin/updateLocale'
dayjs.extend(updateLocale)
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)


dayjs.updateLocale('en', {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'a moment',
        m: "a minute",
        mm: "%d mins",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
})



dayjs.updateLocale('de', {
    relativeTime: {
        future: "in %s",
        past: "vor %s",
        s: 'einem Moment', // in einem Moment - vor einem Moment
        m: "einer Minute", // in einer Minute - vor einer Minute
        mm: "%d Minuten", // in 6 Minuten - vor 6 Minuten
        h: "einer Stunde", // in einer Stunde - vor einer Stunde
        hh: "%d hours", // in 6 Stunden - vor 6 Stunden
        d: "einem Tag",
        dd: "%d Tagen",
        M: "einem Monat",
        MM: "%d Monaten",
        y: "einem Jahr",
        yy: "%d Jahren"
    }
})



dayjs.updateLocale('es', {
    relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: 'un momento',
        m: "einer minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un dia",
        dd: "%d dias",
        M: "un mes",
        MM: "%d meses",
        y: "en un año",
        yy: "%d años"
    }
})


dayjs.updateLocale("nl", {
    relativeTime: {
        future: "in %s",
        past: "%s geleden",
        s: "een moment",
        m: "een minuut",
        mm: "%d minuten",
        h: "een uur",
        hh: "%d uren",
        d: "een dag",
        dd: "%d dagen",
        M: "een maand",
        MM: "%d maanden",
        y: "een jaar",
        yy: "%d jaar"
    }
})

dayjs.updateLocale("fr", {
    relativeTime: {
        future: "dans % s",
        past: "il y a % s",
        s: "un instant",
        m: "une minute",
        mm: "% d minutes",
        h: "une heure",
        hh: "% d heures",
        d: "un jour",
        dd: "% d jours",
        M: "un mois",
        MM: "% d mois",
        y: "une année",
        yy: "% d années"
    }
})

dayjs.updateLocale(dayjs.locale(), {
  weekStart: 1,
})


export default  dayjs